import { DomeComponent, DomeManipulator, React } from "@lexriver/dome"
import { Currency } from "../../Currency"
import { Settings } from "../../Settings"
import { JsonBasketRow } from "../json-data-types/JsonBasketRow"
import css from './BasketRow.m.scss'
import { Price } from "./Price"

interface Attrs{
    type:'wholesale'|'retail'
    strong?:boolean
    getPrefix:()=>string|HTMLElement, showIf1Quantity:boolean
    row:JsonBasketRow
}

export class BasketRowPriceSum extends DomeComponent<Attrs>{
    render(){
        return <div></div>
    }

    afterRender(){
        this.scheduleUpdate()
    }

    async updateAsync(){
        await DomeManipulator.replaceAllChildrenAsync(this.rootElement, this.getRender())
    }

    protected getRender(){
        //console.log('___ getRender()', 'price=', this.attrs.price, 'quantity=', this.attrs.quantity, 'prefix=', this.attrs.getPrefix())
        // if(!this.attrs.product || !this.attrs.quantity) return null
        if(this.attrs.row.quantity === 1 && !this.attrs.showIf1Quantity) return null
        //return <div class={css.price}>{Settings.formatNumberToPrice(this.attrs.product.retailPrice * this.attrs.quantity)}</div>

        const priceWithoutDiscount = this.attrs.type == 'wholesale'
            ? this.attrs.row.product.wholesalePrice * this.attrs.row.quantity
            : this.attrs.row.product.retailPrice*this.attrs.row.quantity

        const dollarPriceWithoutDiscount = this.attrs.type == 'wholesale'
            ? (this.attrs.row.product.wholesalePriceDollar || 0) * this.attrs.row.quantity
            : (this.attrs.row.product.retailPriceDollar || 0) * this.attrs.row.quantity


        const lineDiscountRub = this.getLineDiscountRub()

        if(lineDiscountRub ==0 ){
            return <>
                <div class={css.label}>
                    {this.attrs.getPrefix()}
                    {/* розн&nbsp;сумма&nbsp; */}
                </div>
                <div class={css.value}>
                    {this.attrs.strong 
                        ? <strong>
                            <Price price={priceWithoutDiscount} priceInDollar={dollarPriceWithoutDiscount} />
                          </strong>
                        : <Price price={priceWithoutDiscount} priceInDollar={dollarPriceWithoutDiscount} />
                    }
                    
                </div>
            </>
        } 

        const priceWithDiscount = priceWithoutDiscount - lineDiscountRub
        // proportion:
        //      priceWithoutDiscount | dollarPriceWithoutDiscount
        //      priceWithDiscount    | x
        const dollarPriceWithDiscount = Currency.roundTo2Decimals(priceWithDiscount * dollarPriceWithoutDiscount / priceWithoutDiscount)

        return <>
            <div class={css.label}>
                {this.attrs.getPrefix()}
                {/* розн&nbsp;сумма&nbsp; */}
            </div>
            <div class={css.value}>
                <strike><Price price={priceWithoutDiscount} priceInDollar={dollarPriceWithoutDiscount} /></strike><br/>
                {this.attrs.strong
                    ? <strong><Price price={priceWithDiscount} priceInDollar={dollarPriceWithDiscount} /></strong>
                    : <Price price={priceWithDiscount} priceInDollar={dollarPriceWithDiscount} />
                }
                
            </div>
        </>

    }

    getLineDiscountRub(){
        if (this.attrs.row.lineDiscountKopecksByCouponCode) {
            let result = 0
            for (const discountKopecks of Object.values(this.attrs.row.lineDiscountKopecksByCouponCode)) {
                result += discountKopecks
            }
            return result / 100
        }

        let result = 0
        for(let [code,discount] of Object.entries(this.attrs.row.discountByCouponCodeInRub)){
            result += discount
        }
        return result * this.attrs.row.quantity
    }

}


